unit UResultModel;

interface

uses
  Js;

type
  TResultModel = class
  private
    FResultMessage: string;
    FResultValue: Boolean;
    procedure ClearValues;
    procedure SetValues(obj: TJsObject); overload;
    procedure SetValues(json: string); overload;
    procedure SetResultMessage(const Value: string);
    procedure SetResultValue(const Value: Boolean);
  public
    constructor Create; overload;
    constructor Create(json: string); overload;
    property ResultValue: Boolean read FResultValue write SetResultValue;
    property ResultMessage: string read FResultMessage write SetResultMessage;
  end;

implementation

uses
  UEssentialHelper;

{ TResultModel }

procedure TResultModel.ClearValues;
begin
  Self.ResultValue := true;
  Self.ResultMessage := '';
end;

constructor TResultModel.Create;
begin
  Self.ClearValues;
end;

constructor TResultModel.Create(json: string);
begin
  Self.SetValues(json);
end;

procedure TResultModel.SetResultMessage(const Value: string);
begin
  FResultMessage := Value;
end;

procedure TResultModel.SetResultValue(const Value: Boolean);
begin
  FResultValue := Value;
end;

procedure TResultModel.SetValues(json: string);
var
  obj: TJsObject;
begin
  obj := TJsJson.parseObject(json);
  Self.SetValues(obj);
end;

procedure TResultModel.SetValues(obj: TJsObject);
begin
  Self.ClearValues;
  if obj['ResultValue'] <> nil then
    Self.ResultValue := StrToBoolean(string(obj['ResultValue']));
  if obj['ResultMessage'] <> nil then
    Self.ResultMessage := string(obj['ResultMessage']);
end;

end.
